<template>
  <div>
    <router-link class="Logo" to="/">
      <img src="../assets/logo.svg" alt="Logo">
    </router-link>
    <Hero />
    <Footer />
  </div>
</template>

<script>
import Hero from '../components/Hero.vue'
import Footer from '../components/Footer.vue'

export default {
  name: 'Home',
  components: {
    Hero,
    Footer
  },
  mounted() {
    this.$store.dispatch({
     type: 'resetAnswers'
    });
    // 2025: campid aus der URL wird bewusst ignoriert – es gilt immer
    // der im Store hinterlegte Default (40613-120-16-101.1).
  }
}
</script>

<style lang="scss" scoped>

</style>
